/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListProductsCatalogQueryResponse,
  ListProductsCatalogQueryParams,
} from '../../types/ListProductsCatalog'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listProductsCatalog } from '../../clients/listProductsCatalog'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listProductsCatalogQueryKey = (
  params?: ListProductsCatalogQueryParams
) =>
  [
    { url: '/api/v1/products/catalog/products/' },
    ...(params ? [params] : []),
  ] as const

export type ListProductsCatalogQueryKey = ReturnType<
  typeof listProductsCatalogQueryKey
>

export function listProductsCatalogQueryOptions(
  params?: ListProductsCatalogQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listProductsCatalogQueryKey(params)
  return queryOptions<
    ListProductsCatalogQueryResponse,
    ResponseErrorConfig<Error>,
    ListProductsCatalogQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listProductsCatalog(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Get paginated products catalog.
 * Query Parameters:
 * - search: Search by product name
 * - type: Filter type for multi-select logic (one, all, neither)
 * - sort/ordering: Field to sort by (with optional - prefix for descending)
 * - page: Page number (default: 1)
 * - limit/page_size: Items per page (default: 50, max: 1000)
 * Range Filters (use _greater/_less suffixes):
 * - avg_serving_size_per_lb_greater/less: Filter by avg volume per unit
 * - mfg_avg_list_price_per_lb_greater/less: Filter by avg revenue per unit
 * - est_monthly_churn_rate_greater/less: Filter by churn rate
 * - estimated_sales_potential_greater/less: Filter by avg units sold per month
 * - variants_count_greater/less: Filter by number of variants
 * Date Range Filters (use _greater/_less suffixes):
 * - created_greater/less: Filter by creation date
 * - modified_greater/less: Filter by modification date
 * Returns:
 * {
 * "results": [...],
 * "count": total_count,
 * "page": page,
 * "page_size": page_size
 * }
 * @summary List products catalog
 * {@link /api/v1/products/catalog/products/}
 */
export function useListProductsCatalog<
  TData = ListProductsCatalogQueryResponse,
  TQueryData = ListProductsCatalogQueryResponse,
  TQueryKey extends QueryKey = ListProductsCatalogQueryKey,
>(
  params?: ListProductsCatalogQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListProductsCatalogQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listProductsCatalogQueryKey(params)

  const query = useQuery(
    {
      ...listProductsCatalogQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
